<mat-checkbox
    [ngClass]="{'full-width': fullWidth}" [attr.aria-label]="value"
    [labelPosition]="labelPosition"
    [disabled]
    [(checked)]="value"
    [indeterminate]="indeterminate"
    (change)="valueChanged($event.checked)">
    <ng-content></ng-content>
</mat-checkbox>